import {PageLink, PageTitle} from '../../_metronic/layout/core'
import {ExpenseHeader} from './components/ExpenseHeader'
// import { ListWrapper } from './list/ListWrapper'

const expenseBreadcrumbs: Array<PageLink> = [
  {
    title: 'Gestão de Despesas',
    path: '/franchiseBilling',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ExpensePage = () => {
  return (
    <>
      <PageTitle breadcrumbs={expenseBreadcrumbs}>Lista de Despesas</PageTitle>
      <ExpenseHeader />
    </>
  )
}

export default ExpensePage
